import React from "react";
import { TableColumn } from "../../../../components/table/Table";
import { Destination } from "../../../../models/destination";
import {
  DestinationActionsColumn,
  DestinationCreatedColumn,
  DestinationNameColumn,
  DestinationTemplatesColumn,
  DestinationURLColumn,
} from "./components";

export const destinationColumns: TableColumn<Destination>[] = [
  {
    key: "name",
    title: "Name",
    headerClassName: "text-left w-[35%]",
    render: (destination) => (
      <DestinationNameColumn destination={destination} />
    ),
  },
  {
    key: "url",
    title: "URL",
    headerClassName: "text-left w-[35%]",
    render: (destination) => <DestinationURLColumn destination={destination} />,
  },
  {
    key: "created_at",
    title: "Created",
    headerClassName: "text-left w-[15%]",
    render: (destination) => (
      <DestinationCreatedColumn destination={destination} />
    ),
  },
  {
    key: "template_list",
    title: "Templates",
    headerClassName: "md:text-left w-[5%]",
    render: (destination) => (
      <DestinationTemplatesColumn destination={destination} />
    ),
  },
  {
    key: "destination_id",
    title: "",
    cellClassName: "md:float-right",
    headerClassName: "w-[10%]",
    render: (destination) => (
      <DestinationActionsColumn destination={destination} />
    ),
  },
];
